export default __webpack_public_path__ + "static/media/yellowMarker.55ef8e1a.svg";